import React, { useState, useEffect } from 'react';
import { supabase } from './lib/supabase';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import RawMaterials from './pages/RawMaterials';
import FinishedGoods from './pages/FinishedGoods';
import PurchaseOrders from './pages/PurchaseOrders';
import CustomerOrders from './pages/CustomerOrders';
import ProductionRuns from './pages/ProductionRuns';
import ComponentsPage from './pages/Components';
import BulkParts from './pages/BulkParts';
import PackOutRuns from './pages/PackOutRuns';
import Suppliers from './pages/Suppliers';
import './App.css';

const NAV = [
  { id: 'dashboard',   label: 'Dashboard',       icon: 'M3 3h7v7H3zm11 0h7v7h-7zm0 11h7v7h-7zM3 14h7v7H3z' },
  { id: 'raw',         label: 'Raw Materials',    icon: 'M20 7H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2z' },
  { id: 'components',  label: 'Components',       icon: 'M12 2l9 4.9V17L12 22l-9-4.9V7L12 2z' },
  { id: 'production',  label: 'Production Runs',  icon: 'M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z' },
  { id: 'bulk',        label: 'Bulk Parts',       icon: 'M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z' },
  { id: 'packout',     label: 'Pack-Out Runs',    icon: 'M5 8h14M5 8a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2M5 8V6a2 2 0 0 0 2-2h6a2 2 0 0 0 2 2v2' },
  { id: 'finished',    label: 'Finished Goods',   icon: 'M9 5H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2M9 5a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2M9 5h6' },
  { id: 'po',          label: 'Purchase Orders',  icon: 'M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z' },
  { id: 'ar',          label: 'Customer Orders',  icon: 'M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z' },
  { id: 'suppliers',   label: 'Suppliers',        icon: 'M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8zm14 10v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75' },
];

export default function App() {
  const [session, setSession] = useState(null);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState('dashboard');

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      setSession(session);
      setLoading(false);
    });
    const { data: { subscription } } = supabase.auth.onAuthStateChange((_e, session) => {
      setSession(session);
    });
    return () => subscription.unsubscribe();
  }, []);

  if (loading) return <div className="app-loading">Loading...</div>;
  if (!session) return <Login />;

  const PAGES = {
    dashboard: Dashboard, raw: RawMaterials, components: ComponentsPage,
    production: ProductionRuns, bulk: BulkParts, packout: PackOutRuns,
    finished: FinishedGoods, po: PurchaseOrders, ar: CustomerOrders,
    suppliers: Suppliers,
  };
  const PageComponent = PAGES[page] || Dashboard;

  return (
    <div className="app">
      <nav className="sidebar">
        <div className="sidebar-logo">
          <div className="brand">PAK 1 PLASTICS</div>
          <div className="brand-sub">Inventory Manager</div>
        </div>
        <div className="sidebar-nav">
          {NAV.map(n => (
            <button key={n.id} className={`nav-item ${page === n.id ? 'active' : ''}`} onClick={() => setPage(n.id)}>
              <svg width="15" height="15" fill="none" stroke="currentColor" strokeWidth="1.8" viewBox="0 0 24 24">
                <path d={n.icon} strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
              {n.label}
            </button>
          ))}
        </div>
        <div className="sidebar-footer">
          <div className="user-email">{session.user.email}</div>
          <button className="btn-signout" onClick={() => supabase.auth.signOut()}>Sign out</button>
        </div>
      </nav>
      <main className="main-content">
        <PageComponent navigate={setPage} />
      </main>
    </div>
  );
}
